/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable */
import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home";
import HomeHRD from "../views/HomeHRD";
import EmployeeInfo from "../views/EmployeeInfo";
import HomeModule from "../views/HomeModule";
import HomeAcademic from "../views/HomeAcademic";
import HomeComboard from "../views/HomeComboard";
import NewDashboard from "../views/NewDashboard/Index.vue";
import HomeBooking from "../views/HomeBooking";
import HomeSection from "../views/ParentPage/HomeSection";
import store from "../store/index";

const routes = [
  {
    path: "/auth/:provider/callback",
    component: {
      template: '<div class="auth-component"></div>',
    },
  },
  {
    meta: {
      title: "Dashboard",
      requireLogin: true,
    },
    path: "/",
    name: "home",
    component: Home,
  },
  {
    meta: {
      title: "Dashboard",
      requireLogin: true,
    },
    path: "/dashboard",
    name: "Dashboard",
    component: NewDashboard,
  },
  {
    meta: {
      title: "Dashboard",
      requireLogin: true,
    },
    path: "/comboard-dashboard",
    name: "comboard-dashboard",
    component: HomeComboard,
  },
  {
    meta: {
      title: "Dashboard",
      requireLogin: true,
    },
    path: "/booking-dashboard",
    name: "booking-dashboard",
    component: HomeBooking,
  },
  {
    meta: {
      title: "Dashboard",
      requireLogin: true,
    },
    path: "/academic-dashboard",
    name: "academic-dashboard",
    component: HomeAcademic,
  },
  {
    meta: {
      title: "Dashboard",
      requireLogin: true,
    },
    path: "/hr-dashboard",
    name: "hr-dashboard",
    component: HomeHRD,
  },
  {
    meta: {
      title: "Personal Information",
      requireLogin: true,
    },
    path: "/employee-info",
    name: "Personal Information",
    component: EmployeeInfo,
  },
  {
    meta: {
      title: "Period",
      requireLogin: true,
    },
    path: "/period",
    name: "period.index",
    component: () =>
      import(
        /* webpackChunkName: 'period.index' */ "../views/humanresource/period/Index.vue"
      ),
  },
  {
    meta: {
      title: "Holidays",
      requireLogin: true,
    },
    path: "/holidays",
    name: "holidays.index",
    component: () =>
      import(
        /* webpackChunkName: 'holidays.index' */ "../views/humanresource/holidays/Index.vue"
      ),
  },
  {
    meta: {
      title: "Holidays Detail",
      requireLogin: true,
    },
    path: "/holidays-detail",
    name: "holidaysdetail.index",
    component: () =>
      import(
        /* webpackChunkName: 'holidays.index' */ "../views/humanresource/holidaysDetail/Index.vue"
      ),
  },
  {
    meta: {
      title: "Committe Role",
      requireLogin: true,
    },
    path: "/committe-role",
    name: "committerole.index",
    component: () =>
      import(
        /* webpackChunkName: 'committerole.index' */ "../views/humanresource/committeRole/Index.vue"
      ),
  },
  {
    meta: {
      title: "Career Path",
      requireLogin: true,
    },
    path: "/career-path",
    name: "careerpath.index",
    component: () =>
      import(
        /* webpackChunkName: 'careerpath.index' */ "../views/humanresource/careerPath/Index.vue"
      ),
  },
  {
    meta: {
      title: "Holidays Department",
      requireLogin: true,
    },
    path: "/holidays-department",
    name: "holidaysdepartment.index",
    component: () =>
      import(
        /* webpackChunkName: 'holidays.index' */ "../views/humanresource/holidaysDepartment/Index.vue"
      ),
  },
  {
    meta: {
      title: "Programme",
      requireLogin: true,
    },
    path: "/programme",
    name: "programme.index",
    component: () =>
      import(
        /* webpackChunkName: 'programme.index' */ "../views/humanresource/programme/Index.vue"
      ),
  },
  {
    meta: {
      title: "Programme Owner",
      requireLogin: true,
    },
    path: "/programme-owner",
    name: "programmeowner.index",
    component: () =>
      import(
        /* webpackChunkName: 'programmeOwner.index' */ "../views/humanresource/programmeOwner/Index.vue"
      ),
  },
  {
    meta: {
      title: "Programme Committe",
      requireLogin: true,
    },
    path: "/programme-committe",
    name: "programmecommitte.index",
    component: () =>
      import(
        /* webpackChunkName: 'programmeCommitte.index' */ "../views/humanresource/programmeCommitte/Index.vue"
      ),
  },
  {
    meta: {
      title: "Programme Execution Time",
      requireLogin: true,
    },
    path: "/programme-exception-time",
    name: "progexctime.index",
    component: () =>
      import(
        /* webpackChunkName: 'programmeexceptiontime.index' */ "../views/humanresource/programmeexceptiontime/Index.vue"
      ),
  },
  {
    meta: {
      title: "Programme Execution Time Commitee",
      requireLogin: true,
    },
    path: "/progexctimecomm",
    name: "progexctimecomm.index",
    component: () =>
      import(
        /* webpackChunkName: 'programmeexceptiontimecommitee.index' */ "../views/humanresource/programmeexceptiontimecommitee/Index.vue"
      ),
  },
  {
    meta: {
      title: "Contract Template",
      requireLogin: true,
    },
    path: "/contract-template",
    name: "contracttemplate.index",
    component: () =>
      import(
        /* webpackChunkName: 'contracttemplate.index' */ "../views/humanresource/contractTemplate/Index.vue"
      ),
  },
  {
    meta: {
      title: "Contract Type",
      requireLogin: true,
    },
    path: "/contract-type",
    name: "contracttype.index",
    component: () =>
      import(
        /* webpackChunkName: 'contracttype.index' */ "../views/humanresource/contractType/Index.vue"
      ),
  },
  {
    meta: {
      title: "Employee Contract",
      requireLogin: true,
    },
    path: "/employee-contract",
    name: "employeecontract.index",
    component: () =>
      import(
        /* webpackChunkName: 'employeecontract.index' */ "../views/humanresource/employeeContract/Index.vue"
      ),
  },
  {
    meta: {
      title: "Employee Training",
      requireLogin: true,
    },
    path: "/employee-training",
    name: "employeetraining.index",
    component: () =>
      import(
        /* webpackChunkName: 'employeetraining.index' */ "../views/humanresource/employeetraining/Index.vue"
      ),
  },
  {
    meta: {
      title: "Employee Training File",
      requireLogin: true,
    },
    path: "/employee-training-file",
    name: "employeetrainingfile.index",
    component: () =>
      import(
        /* webpackChunkName: 'employeetrainingfile.index' */ "../views/humanresource/employeetrainingfile/Index.vue"
      ),
  },
  {
    meta: {
      title: "Instrument",
      requireLogin: true,
    },
    path: "/instrument",
    name: "instrument.index",
    component: () =>
      import(
        /* webpackChunkName: 'instrument.index' */ "../views/humanresource/instrument/Index.vue"
      ),
  },
  {
    meta: {
      title: "Options",
      requireLogin: true,
    },
    path: "/options",
    name: "options.index",
    component: () =>
      import(
        /* webpackChunkName: 'options.index' */ "../views/humanresource/options/Index.vue"
      ),
  },
  {
    meta: {
      title: "Options Detail",
      requireLogin: true,
    },
    path: "/optionsdetail",
    name: "optionsdetail.index",
    component: () =>
      import(
        /* webpackChunkName: 'optionsdetail.index' */ "../views/humanresource/optionsdetail/Index.vue"
      ),
  },
  {
    meta: {
      title: "Reviewer Composition",
      requireLogin: true,
    },
    path: "/reviewercomposition",
    name: "reviewercomposition.index",
    component: () =>
      import(
        /* webpackChunkName: 'reviewercomposition.index' */ "../views/humanresource/reviewercomposition/Index.vue"
      ),
  },
  {
    meta: {
      title: "Indicator",
      requireLogin: true,
    },
    path: "/indicator",
    name: "indicator.index",
    component: () =>
      import(
        /* webpackChunkName: 'indicator.index' */ "../views/humanresource/indicator/Index.vue"
      ),
  },
  {
    meta: {
      title: "Indicator Target",
      requireLogin: true,
    },
    path: "/indicatortarget",
    name: "indicatortarget.index",
    component: () =>
      import(
        /* webpackChunkName: 'indicatortarget.index' */ "../views/humanresource/indicatortarget/Index.vue"
      ),
  },
  {
    meta: {
      title: "/Responsibility Role",
      requireLogin: true,
    },
    path: "/hrresponsibilityrole",
    name: "hrresponsibilityrole.index",
    component: () =>
      import(
        /* webpackChunkName: 'hrresponsibilityrole.index' */ "../views/humanresource/hrresponsibilityrole/Index.vue"
      ),
  },
  {
    meta: {
      title: "Position",
      requireLogin: true,
    },
    path: "/hrposition",
    name: "hrposition.index",
    component: () =>
      import(
        /* webpackChunkName: 'hrposition.index' */ "../views/humanresource/hrposition/ListTree/Index.vue"
      ),
    // component: () => import(/* webpackChunkName: 'hrposition.index' */ '../views/humanresource/hrposition/Index.vue')
  },
  {
    meta: {
      title: "Setting for Expiring Date",
      requireLogin: true,
    },
    path: "/setting-expired-employee",

    name: "settingexpiredemployee.index",
    component: () =>
      import(
        /* webpackChunkName: 'settingexpiredemployee.index' */ "../views/humanresource/settingexpiredemployee/Index.vue"
      ),
  },
  {
    meta: {
      title: "Leave",
      requireLogin: true,
    },
    path: "/mleave",
    name: "mleave.index",
    component: () =>
      import(
        /* webpackChunkName: 'mleave.index' */ "../views/humanresource/mleave/Index.vue"
      ),
  },
  {
    meta: {
      title: "Leave Dashboard",
      requireLogin: true,
    },
    path: "/leave-dashboard",
    name: "DashboardLeave",
    component: () =>
      import(
        /* webpackChunkName: 'hrleavebalance.index' */ "../views/Dashboard/HRD/DashboardLeave.vue"
      ),
  },
  {
    meta: {
      title: "Leave Balance",
      requireLogin: true,
    },
    path: "/leave-balance",
    name: "hrleavebalance.index",
    component: () =>
      import(
        /* webpackChunkName: 'hrleavebalance.index' */ "../views/humanresource/hrleavebalance/Index.vue"
      ),
  },
  {
    meta: {
      title: "Leave Request",
      requireLogin: true,
    },
    path: "/leave-request",
    name: "hrreqleave.index",
    component: () =>
      import(
        /* webpackChunkName: 'hrreqleave.index' */ "../views/humanresource/hrreqleave/Index.vue"
      ),
  },
  {
    meta: {
      title: "Leave Addition",
      requireLogin: true,
    },
    path: "/leave-addition",
    name: "hrleaveaddition.index",
    component: () =>
      import(
        /* webpackChunkName: 'hrleaveaddition.index' */ "../views/humanresource/hrleaveaddition/Index.vue"
      ),
  },
  {
    meta: {
      title: "Leave Calendar",
      requireLogin: true,
    },
    path: "/leave-calendar",
    name: "hrleaveCalendar.index",
    component: () =>
      import(
        /* webpackChunkName: 'hrleaveCalendar.index' */ "../views/humanresource/hrleaveCalendar/Index.vue"
      ),
  },
  {
    meta: {
      title: "Summary",
      requireLogin: true,
    },
    path: "/leave-summary",
    name: "Summary",
    component: () =>
      import(
        /* webpackChunkName: 'leaveSummary.index' */ "../views/humanresource/leaveSummary/Index.vue"
      ),
  },
  {
    meta: {
      title: "Dashboard",
      requireLogin: true,
    },
    path: "/home-module",
    name: "home-module",
    component: HomeModule,
  },
  {
    meta: {
      title: "Subject Selection",
      requireLogin: true,
    },
    path: "/subject-selection",
    name: "",
    component: () =>
      import(
        /* webpackChunkName: 'SubjectSelection.index' */ "../views/SubjectSelection.vue"
      ),
  },
  {
    meta: {
      title: "Interest Selection",
      requireLogin: true,
    },
    path: "/interest-selection",
    name: "",
    component: () =>
      import(
        /* webpackChunkName: 'InterestSelection.index' */ "../views/InterestSelection.vue"
      ),
  },
  {
    meta: {
      title: "Login",
      fullScreen: true,
    },
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "login" */ "../views/Login"),
  },
  // {
  //   meta: {
  //     title: 'Login Student',
  //     fullScreen: true
  //   },
  //   path: '/login-student',
  //   name: 'Login Student',
  //   component: () => import(/* webpackChunkName: "LoginStudent" */ '../views/LoginStudent')
  // },
  {
    meta: {
      title: "Change Password",
      fullScreen: true,
    },
    path: "/change-password",
    name: "Change Password Admin",
    component: () =>
      import(
        /* webpackChunkName: "ChangePassword" */ "../views/ChangePassword"
      ),
  },
  {
    meta: {
      title: "Change Password",
      fullScreen: true,
    },
    path: "/change-password-booking",
    name: "Change Password Booking",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/ChangePassword"),
  },
  {
    meta: {
      title: "Change Password Parent",
      fullScreen: true,
    },
    path: "/change-password-parent",
    name: "Change Password Parent",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/ChangePassword"),
  },
  {
    meta: {
      title: "Change Password Student",
      fullScreen: true,
    },
    path: "/change-password-student",
    name: "Change Password Student",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/ChangePassword"),
  },
  {
    meta: {
      title: "Reset Password",
      fullScreen: true,
    },
    path: "/reset-password",
    name: "Reset Password",
    component: () =>
      import(/* webpackChunkName: "reset-password" */ "../views/ResetPassword"),
  },
  // {
  //   meta: {
  //     title: 'Register',
  //     fullScreen: true
  //   },
  //   path: '/register',
  //   name: 'Register',
  //   component: () => import(/* webpackChunkName: "register" */ '../views/Register')
  // },
  {
    meta: {
      title: "Class",
      requireLogin: true,
      progress: {
        func: [
          { call: "color", modifier: "temp", argument: "#ffb000" },
          { call: "fail", modifier: "temp", argument: "#6e0000" },
          { call: "location", modifier: "temp", argument: "top" },
          {
            call: "transition",
            modifier: "temp",
            argument: { speed: "1.5s", opacity: "0.6s", termination: 1400 },
          },
        ],
      },
    },
    path: "/class",
    name: "class.index",
    component: () =>
      import(
        /* webpackChunkName: 'class.index' */ "../views/referensi/class/Index.vue"
      ),
  },
  {
    meta: {
      title: "Subject",
      requireLogin: true,
    },
    path: "/subject",
    name: "subject.index",
    component: () =>
      import(
        /* webpackChunkName: 'subject.index' */ "../views/subject/subject/Index.vue"
      ),
  },
  {
    meta: {
      title: "Semester",
      requireLogin: true,
    },
    path: "/semester",
    name: "semester.index",
    component: () =>
      import(
        /* webpackChunkName: 'semester.index' */ "../views/referensi/semester/Index.vue"
      ),
  },
  {
    meta: {
      title: "Level",
      requireLogin: true,
    },
    path: "/level",
    name: "level.index",
    component: () =>
      import(
        /* webpackChunkName: 'level.index' */ "../views/referensi/level/Index.vue"
      ),
  },
  {
    meta: {
      title: "Phase",
      requireLogin: true,
    },
    path: "/phase",
    name: "phase.index",
    component: () =>
      import(
        /* webpackChunkName: 'phase.index' */ "../views/referensi/phase/Index.vue"
      ),
  },
  {
    meta: {
      title: "Building",
      requireLogin: true,
    },
    path: "/building",
    name: "building.index",
    component: () =>
      import(
        /* webpackChunkName: 'building.index' */ "../views/masterroom/building/Index.vue"
      ),
  },
  {
    meta: {
      title: "Activity",
      requireLogin: true,
    },
    path: "/activity",
    name: "activity.index",
    component: () =>
      import(
        /* webpackChunkName: 'activity.index' */ "../views/masterroom/activity/Index.vue"
      ),
  },
  {
    meta: {
      title: "Equipment Room",
      requireLogin: true,
    },
    path: "/equipment",
    name: "equipment.index",
    component: () =>
      import(
        /* webpackChunkName: 'equipment.index' */ "../views/masterroom/equipment/Index.vue"
      ),
  },
  {
    meta: {
      title: "Price List",
      requireLogin: true,
    },
    path: "/pricelist",
    name: "pricelist.index",
    component: () =>
      import(
        /* webpackChunkName: 'pricelist.index' */ "../views/masterroom/pricelist/Index.vue"
      ),
  },
  {
    meta: {
      title: "Student Resignation",
      requireLogin: true,
    },
    path: "/student-resignation",
    name: "studentresignation.index",
    component: () =>
      import(
        /* webpackChunkName: 'studentresignation.index' */ "../views/referensi/studentresignation/Index.vue"
      ),
  },
  {
    meta: {
      title: "Resignation Reason",
      requireLogin: true,
    },
    path: "/resignation-reason",
    name: "resignationreason.index",
    component: () =>
      import(
        /* webpackChunkName: 'resignationreason.index' */ "../views/referensi/resignationreason/Index.vue"
      ),
  },
  {
    meta: {
      title: "Category Fa",
      requireLogin: true,
    },
    path: "/fa-category",
    name: "category.index",
    component: () =>
      import(
        /* webpackChunkName: 'categoryfa.index' */ "../views/masterroom/categoryfa/Index.vue"
      ),
  },
  {
    meta: {
      title: "Facility Condition",
      requireLogin: true,
    },
    path: "/facility-condition",
    name: "condition.index",
    component: () =>
      import(
        /* webpackChunkName: 'facilitycondition.index' */ "../views/masterroom/facilitycondition/Index.vue"
      ),
  },
  {
    meta: {
      title: "Owner",
      requireLogin: true,
    },
    path: "/owner",
    name: "owner.index",
    component: () =>
      import(
        /* webpackChunkName: 'owner.index' */ "../views/masterroom/owner/Index.vue"
      ),
  },
  {
    meta: {
      title: "Tenant",
      requireLogin: true,
    },
    path: "/tenant",
    name: "tenant.index",
    component: () =>
      import(
        /* webpackChunkName: 'tenant.index' */ "../views/masterroom/tenant/Index.vue"
      ),
  },
  {
    meta: {
      title: "Graduation",
      requireLogin: true,
    },
    path: "/graduation",
    name: "graduation.index",
    component: () =>
      import(
        /* webpackChunkName: 'graduation.index' */ "../views/referensi/graduation/Index.vue"
      ),
  },
  {
    meta: {
      title: "Departemen",
      requireLogin: true,
    },
    path: "/department",
    name: "department.index",
    component: () =>
      import(
        /* webpackChunkName: 'department.index' */ "../views/referensi/department/Index.vue"
      ),
  },
  {
    meta: {
      title: "Employee",
      requireLogin: true,
    },
    path: "/employee",
    name: "employee.index",
    component: () =>
      import(
        /* webpackChunkName: 'employee.index' */ "../views/referensi/employee/Index.vue"
      ),
  },
  {
    meta: {
      title: "Special Employee Assignments",
      requireLogin: true,
    },
    path: "/employee-special-assignments",
    name: "Special Employee Assignments",
    component: () =>
      import(
        /* webpackChunkName: 'employee.EmployeeAttendance' */ "../views/referensi/employee/EmployeeAssignment/Index.vue"
      ),
  },
  {
    meta: {
      title: "Employee Daily Attendance",
      requireLogin: true,
    },
    path: "/employee-daily-attendance",
    name: "Employee Daily Attendance",
    component: () =>
      import(
        /* webpackChunkName: 'EmployeeDaily.Index' */ "../views/referensi/employee/EmployeeDaily/Index.vue"
      ),
  },
  {
    meta: {
      title: "Employee Attendance Report",
      requireLogin: true,
    },
    path: "/employee-attendance-report",
    name: "Employee Attendance Report",
    component: () =>
      import(
        /* webpackChunkName: 'employee.EmployeeAttendance' */ "../views/referensi/employee/EmployeeAttendance.vue"
      ),
  },
  {
    meta: {
      title: "Employee Calendar",
      requireLogin: true,
    },
    path: "/employee-calendar",
    name: "employeecalendar.index",
    component: () =>
      import(
        /* webpackChunkName: 'employeecalendar.index' */ "../views/referensi/employee/CalendarAttendance.vue"
      ),
  },
  {
    meta: {
      title: "Employee Career Path",
      requireLogin: true,
    },
    path: "/employee-career-path",
    name: "employeecareerpath.index",
    component: () =>
      import(
        /* webpackChunkName: 'employeecareerpath.index' */ "../views/referensi/employeeCareerPath/Index.vue"
      ),
  },
  {
    meta: {
      title: "Academic Year",
      requireLogin: true,
    },
    path: "/academic-year",
    name: "academicyear.index",
    component: () =>
      import(
        /* webpackChunkName: 'academicyear.index' */ "../views/referensi/academicyear/Index.vue"
      ),
  },
  {
    meta: {
      title: "Academic Batch",
      requireLogin: true,
    },
    path: "/academic-batch",
    name: "academicbatch.index",
    component: () =>
      import(
        /* webpackChunkName: 'academicbatch.index' */ "../views/referensi/academicbatch/Index.vue"
      ),
  },
  {
    meta: {
      title: "Extracuricular",
      requireLogin: true,
    },
    path: "/extracuricular",
    name: "extracuricular.index",
    component: () =>
      import(
        /* webpackChunkName: 'extracuricular.index' */ "../views/referensi/extracuricular/Index.vue"
      ),
  },
  {
    meta: {
      title: "Extracuricular Attendance",
      requireLogin: true,
    },
    path: "/extracuricular-attendance",
    name: "Extracuricular Attendance",
    component: () =>
      import(
        /* webpackChunkName: 'Attendance.index' */ "../views/referensi/extracuricular/Attendance/Index.vue"
      ),
  },
  {
    meta: {
      title: "Student Extracuricular",
      requireLogin: true,
    },
    path: "/extracuricular-student",
    name: "extracuricularstudent.index",
    component: () =>
      import(
        /* webpackChunkName: 'extracuricular.index' */ "../views/referensi/extracuricular/extracuricularstudent/Index.vue"
      ),
  },
  {
    meta: {
      title: "Student Extracuricular Selection",
      requireLogin: true,
    },
    path: "/extracuricular-student-select",
    name: "extracuricularstudentselect.index",
    component: () =>
      import(
        /* webpackChunkName: 'extracuricular.index' */ "../views/referensi/extracuricular/extracuricularstudentselect/Index.vue"
      ),
  },
  {
    meta: {
      title: "Extracuricular Group",
      requireLogin: true,
    },
    path: "/extracuricular-group",
    name: "extracuriculagroup.index",
    component: () =>
      import(
        /* webpackChunkName: 'extracuricular.index' */ "../views/referensi/extracuricular/group/Index.vue"
      ),
  },
  {
    meta: {
      title: "Report Extracuricular",
      requireLogin: true,
    },
    path: "/extracuricularbarchart",
    name: "extracuricularbarchart.index",
    component: () =>
      import(
        /* webpackChunkName: 'extracuricular.index' */ "../views/referensi/extracuricular/ReportIndex.vue"
      ),
  },
  {
    meta: {
      title: "Vaccine",
      requireLogin: true,
    },
    path: "/vaccine",
    name: "vaccines.index",
    component: () =>
      import(
        /* webpackChunkName: 'vaccines.index' */ "../views/referensi/vaccines/Index.vue"
      ),
  },
  {
    meta: {
      title: "School Identity",
      requireLogin: true,
    },
    path: "/schoolidentity",
    name: "schoolidentity.index",
    component: () =>
      import(
        /* webpackChunkName: 'schoolidentity.index' */ "../views/referensi/schoolidentity/Index.vue"
      ),
  },
  {
    meta: {
      title: "Comment",
      requireLogin: true,
    },
    path: "/comment",
    name: "comment.index",
    component: () =>
      import(
        /* webpackChunkName: 'comment.index' */ "../views/referensi/comment/Index.vue"
      ),
  },
  {
    meta: {
      title: "Branch",
      requireLogin: true,
    },
    path: "/branch",
    name: "branch.index",
    component: () =>
      import(
        /* webpackChunkName: 'branch.index' */ "../views/referensi/branch/Index.vue"
      ),
  },
  {
    meta: {
      title: "Credit Status",
      requireLogin: true,
    },
    path: "/credit-status",
    name: "Credit Status",
    component: () =>
      import(
        /* webpackChunkName: 'creditStatus.index' */ "../views/referensi/creditStatus/Index.vue"
      ),
  },
  {
    meta: {
      title: "Major",
      requireLogin: true,
    },
    path: "/major",
    name: "major.index",
    component: () =>
      import(
        /* webpackChunkName: 'major.index' */ "../views/referensi/major/Index.vue"
      ),
  },
  {
    meta: {
      title: "Template Announcement",
      requireLogin: true,
    },
    path: "/template-announcement",
    name: "templateannouncement.index",
    component: () =>
      import(
        /* webpackChunkName: 'templateannouncement.index' */ "../views/masterkeu/templateannouncement/Index.vue"
      ),
  },
  {
    meta: {
      title: "Batch Registration",
      requireLogin: true,
    },
    path: "/batch-registration",
    name: "regisbatch.index",
    component: () =>
      import(
        /* webpackChunkName: 'regisbatch.index' */ "../views/referensi/regisbatch/Index.vue"
      ),
  },
  {
    meta: {
      title: "Assignment Type Score",
      requireLogin: true,
    },
    path: "/assignment-type-score",
    name: "assignmenttypescore.index",
    component: () =>
      import(
        /* webpackChunkName: 'assignmenttypescore.index' */ "../views/referensi/assignmenttypescore/Index.vue"
      ),
  },
  {
    meta: {
      title: "New Batch Registration",
      requireLogin: true,
    },
    path: "/new-batch-registration",
    name: "newbatchregistration.index",
    component: () =>
      import(
        /* webpackChunkName: 'newbatchregistration.index' */ "../views/psb/newbatchregistration/Index.vue"
      ),
  },
  {
    meta: {
      title: "Candidates Group",
      requireLogin: true,
    },
    path: "/candidates-group",
    name: "candidatesgroup.index",
    component: () =>
      import(
        /* webpackChunkName: 'candidatesgroup.index' */ "../views/psb/candidatesgroup/Index.vue"
      ),
  },
  {
    meta: {
      title: "Candidate",
      requireLogin: true,
    },
    path: "/candidate",
    name: "candidate.index",
    component: () =>
      import(
        /* webpackChunkName: 'candidate.index' */ "../views/psb/candidate/Index.vue"
      ),
  },
  {
    meta: {
      title: "Candidates Placement",
      requireLogin: true,
    },
    path: "/candidates-placement",
    name: "candidatesplacement.index",
    component: () =>
      import(
        /* webpackChunkName: 'candidatesplacement.index' */ "../views/psb/candidatesplacement/Index.vue"
      ),
  },
  {
    meta: {
      title: "Comboard List",
      requireLogin: true,
    },
    path: "/comboardlist",
    name: "comboard.index",
    component: () =>
      import(
        /* webpackChunkName: 'comboard.index' */ "../views/comboards/comboard/Index.vue"
      ),
  },
  {
    meta: {
      title: "Comboard User",
      requireLogin: true,
    },
    path: "/comboarduser",
    name: "comboarduser.index",
    component: () =>
      import(
        /* webpackChunkName: 'comboarduser.index' */ "../views/comboards/comboarduser/Index.vue"
      ),
  },
  {
    meta: {
      title: "Comboard Category",
      requireLogin: true,
    },
    path: "/comboardcategory",
    name: "comboardcategory.index",
    component: () =>
      import(
        /* webpackChunkName: 'comboardcategory.index' */ "../views/comboards/comboardcategory/Index.vue"
      ),
  },
  {
    meta: {
      title: "Comboard Recipients",
      requireLogin: true,
    },
    path: "/comboardrecipients",
    name: "comboardrecipients.index",
    component: () =>
      import(
        /* webpackChunkName: 'comboardrecipients.index' */ "../views/comboards/comboardrecipients/Index.vue"
      ),
  },
  {
    meta: {
      title: "Students",
      requireLogin: true,
    },
    path: "/students",
    name: "students.index",
    component: () =>
      import(
        /* webpackChunkName: 'students.index' */ "../views/students/students/Index.vue"
      ),
  },
  {
    meta: {
      title: "Siblings Report",
      requireLogin: true,
    },
    path: "/siblings-report",
    name: "Siblings Report",
    component: () =>
      import(
        /* webpackChunkName: 'siblings.index' */ "../views/students/siblings/Index.vue"
      ),
  },
   {
    meta: {
      title: "Under CMA",
      requireLogin: true,
    },
    path: "/under-cma",
    name: "Under CMA",
    component: () =>
      import(
        /* webpackChunkName: 'cma.index' */ "../views/students/cma/Index.vue"
      ),
  },
  {
    meta: {
      title: "Generate",
      requireLogin: true,
    },
    path: "/generate-userid",
    name: "generate.index",
    component: () =>
      import(
        /* webpackChunkName: 'generate.index' */ "../views/students/generate/Index.vue"
      ),
  },
  {
    meta: {
      title: "Teacher",
      requireLogin: true,
    },
    path: "/teacher",
    name: "teacher.index",
    component: () =>
      import(
        /* webpackChunkName: 'teacher.index' */ "../views/teacher/teacher/Index.vue"
      ),
  },
  {
    meta: {
      title: "Teacher Role",
      requireLogin: true,
    },
    path: "/teacherrole",
    name: "teacherrole.index",
    component: () =>
      import(
        /* webpackChunkName: 'teacherrole.index' */ "../views/teacher/teacherrole/Index.vue"
      ),
  },
  {
    meta: {
      title: "Extracurricular Teacher",
      requireLogin: true,
    },
    path: "/teacher-extracuricular",
    name: "teacherextracuricular.index",
    component: () =>
      import(
        /* webpackChunkName: 'teacherextracuricular.index' */ "../views/teacher/teacherextracuricular/Index.vue"
      ),
  },
  {
    meta: {
      title: "Teacher Note",
      requireLogin: true,
    },
    path: "/teacher-note",
    name: "teacherNote.index",
    component: () =>
      import(
        /* webpackChunkName: 'teacherNote.index' */ "../views/teacher/teacherNote/Index.vue"
      ),
  },
  {
    meta: {
      title: "Scan Asset",
      requireLogin: true,
    },
    path: "/scan-asset",
    name: "scanasset.index",
    component: () =>
      import(
        /* webpackChunkName: 'scanasset.index' */ "../views/teacher/scanasset/Index.vue"
      ),
  },
  {
    meta: {
      title: "Scan Asset Location",
      requireLogin: true,
    },
    path: "/scan-asset-location",
    name: "scanassetlocation.index",
    component: () =>
      import(
        /* webpackChunkName: 'scanassetlocation.index' */ "../views/teacher/scanassetlocation/Index.vue"
      ),
  },
  {
    meta: {
      title: "Teacher Journal",
      requireLogin: true,
    },
    path: "/teacherjournal",
    name: "teacherjournal.index",
    component: () =>
      import(
        /* webpackChunkName: 'teacherjournal.index' */ "../views/teacher/teacherjournal/Index.vue"
      ),
  },
  {
    meta: {
      title: "Student Observation",
      requireLogin: true,
    },
    path: "/student-observation",
    name: "studentobservation.index",
    component: () =>
      import(
        /* webpackChunkName: 'studentobservation.index' */ "../views/teacher/studentObservation/Index.vue"
      ),
  },
  {
    meta: {
      title: "Subject Group",
      requireLogin: true,
    },
    path: "/subject-group",
    name: "subjectgroup.index",
    component: () =>
      import(
        /* webpackChunkName: 'subjectgroup.index' */ "../views/subject/subjectgroup/Index.vue"
      ),
  },
  {
    meta: {
      title: "Learning Method",
      requireLogin: true,
    },
    path: "/learning-method",
    name: "learningmethod.index",
    component: () =>
      import(
        /* webpackChunkName: 'learningmethod.index' */ "../views/subject/learningmethod/Index.vue"
      ),
  },
  {
    meta: {
      title: "Grading Aspects",
      requireLogin: true,
    },
    path: "/grading-aspects",
    name: "gradingaspects.index",
    component: () =>
      import(
        /* webpackChunkName: 'gradingaspects.index' */ "../views/subject/gradingaspects/Index.vue"
      ),
  },
  {
    meta: {
      title: "Aspect Academic Year",
      requireLogin: true,
    },
    path: "/aspect-academic-year",
    name: "AspectAcademicYear.index",
    component: () =>
      import(
        /* webpackChunkName: 'AspectAcademicYear.index' */ "../views/subject/AspectAcademicYear/Index.vue"
      ),
  },
  {
    meta: {
      title: "Aspect Assignment Level",
      requireLogin: true,
    },
    path: "/aspect-assignment-level",
    name: "AspectAssignmentLevel.index",
    component: () =>
      import(
        /* webpackChunkName: 'AspectAssignmentLevel.index' */ "../views/subject/AspectAssignmentLevel/Index.vue"
      ),
  },
  {
    meta: {
      title: "Assignment Type",
      requireLogin: true,
    },
    path: "/assignment-type",
    name: "assignmenttype.index",
    component: () =>
      import(
        /* webpackChunkName: 'assignmenttype.index' */ "../views/subject/assignmenttype/Index.vue"
      ),
  },
  {
    meta: {
      title: "Grading Rule",
      requireLogin: true,
    },
    path: "/grading-rule",
    name: "gradingrule.index",
    component: () =>
      import(
        /* webpackChunkName: 'gradingrule.index' */ "../views/subject/gradingrule/Index.vue"
      ),
  },
  {
    meta: {
      title: "Grading Rule P5",
      requireLogin: true,
    },
    path: "/grading-rule-level",
    name: "gradingrulelevel.index",
    component: () =>
      import(
        /* webpackChunkName: 'gradingrulelevel.index' */ "../views/subject/gradingrulelevel/Index.vue"
      ),
  },
  {
    meta: {
      title: "Final Score Rule",
      requireLogin: true,
    },
    path: "/final-score-rule",
    name: "finalscorerule.index",
    component: () =>
      import(
        /* webpackChunkName: 'finalscorerule.index' */ "../views/subject/finalscorerule/Index.vue"
      ),
  },
  {
    meta: {
      title: "Syllabus",
      requireLogin: true,
    },
    path: "/syllabus",
    name: "syllabus.index",
    component: () =>
      import(
        /* webpackChunkName: 'syllabus.index' */ "../views/subject/syllabus/Index.vue"
      ),
  },
  {
    meta: {
      title: "Copy Syllabus",
      requireLogin: true,
    },
    path: "/copysyllabus",
    name: "syllabuscopy.index",
    component: () =>
      import(
        /* webpackChunkName: 'syllabuscopy.index' */ "../views/subject/syllabuscopy/Index.vue"
      ),
  },
  {
    meta: {
      title: "Teaching Timeplan",
      requireLogin: true,
    },
    path: "/teaching-time-plan",
    name: "teachingtimeplan.index",
    component: () =>
      import(
        /* webpackChunkName: 'teachingtimeplan.index' */ "../views/subject/teachingtimeplan/IndexNew.vue"
      ),
  },
  {
    meta: {
      title: "Lesson Plan",
      requireLogin: true,
    },
    path: "/lesson-plan",
    name: "lessonplan.index",
    component: () =>
      import(
        /* webpackChunkName: 'lessonplan.index' */ "../views/subject/lessonplan/Index.vue"
      ),
  },
  {
    meta: {
      title: "Lesson Plan Summary",
      requireLogin: true,
    },
    path: "/lesson-plan-summary",
    name: "Lesson Plan Summary",
    component: () =>
      import(
        /* webpackChunkName: 'lessonplan.index' */ "../views/subject/lessonplanSummary/Index.vue"
      ),
  },
  {
    meta: {
      title: "Lesson Plan Objective",
      requireLogin: true,
    },
    path: "/lessonplanobjectives",
    name: "lessonplanobjectives.index",
    component: () =>
      import(
        /* webpackChunkName: 'lessonplanobjectives.index' */ "../views/subject/lessonplanobjectives/Index.vue"
      ),
  },
  {
    meta: {
      title: "Punishment Type",
      requireLogin: true,
    },
    path: "/punishment-type",
    name: "punishmenttype.index",
    component: () =>
      import(
        /* webpackChunkName: 'punishmenttype.index' */ "../views/humanresource/punishmentType/Index.vue"
      ),
  },
  {
    meta: {
      title: "Punishment Master",
      requireLogin: true,
    },
    path: "/punishment-master",
    name: "punishmentmaster.index",
    component: () =>
      import(
        /* webpackChunkName: 'punishmentmaster.index' */ "../views/humanresource/punishment/Index.vue"
      ),
  },
  {
    meta: {
      title: "Punishment Transaction",
      requireLogin: true,
    },
    path: "/punishment-transaction",
    name: "punishmenttransaction.index",
    component: () =>
      import(
        /* webpackChunkName: 'punishmenttransaction.index' */ "../views/humanresource/punishmentTransaction/Index.vue"
      ),
  },
  {
    meta: {
      title: "Punishment Report",
      requireLogin: true,
    },
    path: "/punishment-report",
    name: "punishmenttransaction.ReportTrType",
    component: () =>
      import(
        /* webpackChunkName: 'punishmenttransaction.index' */ "../views/humanresource/punishmentTransaction/ReportTrType.vue"
      ),
  },
  {
    meta: {
      title: "Violation Consequencies",
      requireLogin: true,
    },
    path: "/violation-consequencies",
    name: "violationconsequencies.index",
    component: () =>
      import(
        /* webpackChunkName: 'violationconsequencies.index' */ "../views/humanresource/violationConsequencies/Index.vue"
      ),
  },
  {
    meta: {
      title: "Overtime",
      requireLogin: true,
    },
    path: "/over-time",
    name: "transactionovertime.index",
    component: () =>
      import(
        /* webpackChunkName: 'transactionovertime.index' */ "../views/humanresource/transactionOverTime/Index.vue"
      ),
  },
  {
    meta: {
      title: "Overtime Sheet",
      requireLogin: true,
    },
    path: "/over-time-detail",
    name: "transactionOverTimeDetail.index",
    component: () =>
      import(
        /* webpackChunkName: 'transactionOverTimeDetail.index' */ "../views/humanresource/transactionOverTimeDetail/Index.vue"
      ),
  },
  {
    meta: {
      title: "Overtime Report",
      requireLogin: true,
    },
    path: "/over-time-report",
    name: "Overtime Report",
    component: () =>
      import(
        /* webpackChunkName: 'transactionOverTimeReport.index' */ "../views/humanresource/transactionOverTimeReport/Index.vue"
      ),
  },
  {
    meta: {
      title: "Work Hour",
      requireLogin: true,
    },
    path: "/work-hour-transaction",
    name: "transactionworkhour.index",
    component: () =>
      import(
        /* webpackChunkName: 'transactionworkhour.index' */ "../views/humanresource/transactionWorkHour/Index.vue"
      ),
  },
  {
    meta: {
      title: "Work Member",
      requireLogin: true,
    },
    path: "/work-member",
    name: "transactionworkmember.index",
    component: () =>
      import(
        /* webpackChunkName: 'transactionworkmember.index' */ "../views/humanresource/transactionWorkMember/Index.vue"
      ),
  },
  {
    meta: {
      title: "Template Decree",
      requireLogin: true,
    },
    path: "/template-decree",
    name: "templatedecree.index",
    component: () =>
      import(
        /* webpackChunkName: 'templatedecree.index' */ "../views/referensi/templateDecree/Index.vue"
      ),
  },
  {
    meta: {
      title: "Student Parallel Subject",
      requireLogin: true,
    },
    path: "/student-paralel-subject",
    name: "studentparalelsubject.index",
    component: () =>
      import(
        /* webpackChunkName: 'studentparallelsubject.index' */ "../views/subject/studentparallelsubject/Index.vue"
      ),
  },
  {
    meta: {
      title: "Student Subject Selection",
      requireLogin: true,
    },
    path: "/student-select-subject",
    name: "studentselectsubject.index",
    component: () =>
      import(
        /* webpackChunkName: 'studentselectsubject.index' */ "../views/subject/studentselectsubject/Index.vue"
      ),
  },
  {
    meta: {
      title: "School Time",
      requireLogin: true,
    },
    path: "/school-time",
    name: "schooltime.index",
    component: () =>
      import(
        /* webpackChunkName: 'schooltime.index' */ "../views/schedule/schooltime/Index.vue"
      ),
  },
  {
    meta: {
      title: "Study Time",
      requireLogin: true,
    },
    path: "/study-time",
    name: "studytime.index",
    component: () =>
      import(
        /* webpackChunkName: 'studytime.index' */ "../views/schedule/studytime/Index.vue"
      ),
  },
  {
    meta: {
      title: "Extracuricular Schedule",
      requireLogin: true,
    },
    path: "/extracuricular-schedule",
    name: "eskulschedule.index",
    component: () =>
      import(
        /* webpackChunkName: 'eskulschedule.index' */ "../views/schedule/eskulschedule/Index.vue"
      ),
  },
  {
    meta: {
      title: "Schedule",
      requireLogin: true,
    },
    path: "/schedule",
    name: "schedule.index",
    component: () =>
      import(
        /* webpackChunkName: 'schedule.index' */ "../views/schedule/schedule/Index.vue"
      ),
  },
  {
    meta: {
      title: "Calendar",
      requireLogin: true,
    },
    path: "/calendar",
    name: "calendar.index",
    component: () =>
      import(
        /* webpackChunkName: 'calendar.index' */ "../views/schedule/calendar/Index.vue"
      ),
  },
  {
    meta: {
      title: "School Event",
      requireLogin: true,
    },
    path: "/school-events",
    name: "schoolevents.index",
    component: () =>
      import(
        /* webpackChunkName: 'schoolevents.index' */ "../views/schedule/schoolevents/Index.vue"
      ),
  },
  {
    meta: {
      title: "Calendar",
      requireLogin: true,
    },
    path: "/school-events/calendar",
    name: "Calendar.index",
    component: () =>
      import(
        /* webpackChunkName: 'schoolevents.index' */ "../views/schedule/schoolevents/Calendar.vue"
      ),
  },
  {
    meta: {
      title: "Print Calendar",
      requireLogin: true,
    },
    path: "/print",
    name: "Print.index",
    component: () =>
      import(
        /* webpackChunkName: 'calendar.index' */ "../views/schedule/calendar/Print.vue"
      ),
  },
  {
    meta: {
      title: "Extracuricular",
      requireLogin: true,
    },
    path: "/extracuricular",
    name: "extracuricular.index",
    component: () =>
      import(
        /* webpackChunkName: 'extracuricular.index' */ "../views/referensi/extracuricular/Index.vue"
      ),
  },
  {
    meta: {
      title: "School Identity",
      requireLogin: true,
    },
    path: "/schoolidentity",
    name: "schoolidentity.index",
    component: () =>
      import(
        /* webpackChunkName: 'schoolidentity.index' */ "../views/referensi/schoolidentity/Index.vue"
      ),
  },
  {
    meta: {
      title: "Candidates Group",
      requireLogin: true,
    },
    path: "/candidates-group",
    name: "candidatesgroup.index",
    component: () =>
      import(
        /* webpackChunkName: 'candidatesgroup.index' */ "../views/psb/candidatesgroup/Index.vue"
      ),
  },
  {
    meta: {
      title: "Permission Params",
      requireLogin: true,
    },
    path: "/permissions",
    name: "permission.index",
    component: () =>
      import(
        /* webpackChunkName: 'permission.index' */ "../views/permission/Index.vue"
      ),
  },
  {
    meta: {
      title: "Permission Notif",
      requireLogin: true,
    },
    path: "/permission/:type",
    name: "notifdetail/permission.index",
    component: () =>
      import(
        /* webpackChunkName: 'notifdetail.index' */ "../views/NotifDetail/Permission/Index.vue"
      ),
  },
  {
    meta: {
      title: "Permission Reason",
      requireLogin: true,
    },
    path: "/permission-reason",
    name: "permissionreason.index",
    component: () =>
      import(
        /* webpackChunkName: 'permissionreason.index' */ "../views/permissionreason/Index.vue"
      ),
  },
  {
    meta: {
      title: "Role",
      requireLogin: true,
    },
    path: "/role",
    name: "role.index",
    component: () =>
      import(/* webpackChunkName: 'role.index' */ "../views/role/Index.vue"),
  },
  {
    meta: {
      title: "Role Group",
      requireLogin: true,
    },
    path: "/role-group",
    name: "rolegroup.index",
    component: () =>
      import(
        /* webpackChunkName: 'rolegroup.index' */ "../views/rolegroup/Index.vue"
      ),
  },
  {
    meta: {
      title: "Transaction Type",
      requireLogin: true,
    },
    path: "/transaction-type",
    name: "transactiontype.index",
    component: () =>
      import(
        /* webpackChunkName: 'transactiontype.index' */ "../views/transactiontype/Index.vue"
      ),
  },
  {
    meta: {
      title: "Transaction Group",
      requireLogin: true,
    },
    path: "/transaction-group",
    name: "transactiongroup.index",
    component: () =>
      import(
        /* webpackChunkName: 'transactiongroup.index' */ "../views/transactiongroup/Index.vue"
      ),
  },
  {
    meta: {
      title: "Coursework Achievement",
      requireLogin: true,
    },
    path: "/coursework-achievement",
    name: "courseworkachievement.index",
    component: () =>
      import(
        /* webpackChunkName: 'courseworkachievement.index' */ "../views/courseworks/achievement/Index.vue"
      ),
  },
  {
    meta: {
      title: "Student Achievement",
      requireLogin: true,
    },
    path: "/student-achievement",
    name: "studentcourseworkachievement.index",
    component: () =>
      import(
        /* webpackChunkName: 'studentcourseworkachievement.index' */ "../views/courseworks/achievement/Index.vue"
      ),
  },
  {
    meta: {
      title: "Teachers Summary Report",
      requireLogin: true,
    },
    path: "/coursework-teacher",
    name: "courseworkteacher.index",
    component: () =>
      import(
        /* webpackChunkName: 'courseworkteacher.index' */ "../views/courseworks/teacher/Index.vue"
      ),
  },
  {
    meta: {
      title: "Teacher Timesheet",
      requireLogin: true,
    },
    path: "/teacher-timesheet",
    name: "teacherTimesheet.index",
    component: () =>
      import(
        /* webpackChunkName: 'teacherTimesheet.index' */ "../views/courseworks/teacherTimesheet/Index.vue"
      ),
  },
  {
    meta: {
      title: "Completed Coursework",
      requireLogin: true,
    },
    path: "/completed-coursework",
    name: "completedCoursework.index",
    component: () =>
      import(
        /* webpackChunkName: 'completedCoursework.index' */ "../views/courseworks/completedCoursework/Index.vue"
      ),
  },
  {
    meta: {
      title: "Coursework",
      requireLogin: true,
    },
    path: "/coursework",
    name: "coursework.index",
    component: () =>
      import(
        /* webpackChunkName: 'coursework.index' */ "../views/courseworks/coursework/Index.vue"
      ),
  },
  {
    meta: {
      title: "Price Group",
      requireLogin: true,
    },
    path: "/price-group",
    name: "pricegroup.index",
    component: () =>
      import(
        /* webpackChunkName: 'pricegroup.index' */ "../views/courseworks/pricegroup/Index.vue"
      ),
  },
  {
    meta: {
      title: "Price List",
      requireLogin: true,
    },
    path: "/price-list",
    name: "price-list.index",
    component: () =>
      import(
        /* webpackChunkName: 'price-list.index' */ "../views/courseworks/pricelist/Index.vue"
      ),
  },
  {
    meta: {
      title: "Non-Academic Activities",
      requireLogin: true,
    },
    path: "/non-academic-activity",
    name: "nonacademicactivity.index",
    component: () =>
      import(
        /* webpackChunkName: 'nonacademicactivity.index' */ "../views/courseworks/nonacademicactivity/Index.vue"
      ),
  },
  {
    meta: {
      title: "Teacher Role",
      requireLogin: true,
    },
    path: "/teacherrole",
    name: "teacherrole.index",
    component: () =>
      import(
        /* webpackChunkName: 'teacherrole.index' */ "../views/teacher/teacherrole/Index.vue"
      ),
  },
  {
    meta: {
      title: "Teacher Journal",
      requireLogin: true,
    },
    path: "/teacherjournal",
    name: "teacherjournal.index",
    component: () =>
      import(
        /* webpackChunkName: 'teacherjournal.index' */ "../views/teacher/teacherjournal/Index.vue"
      ),
  },
  {
    meta: {
      title: "Grading Master",
      requireLogin: true,
    },
    path: "/grading-master",
    name: "gradingmaster.index",
    component: () =>
      import(
        /* webpackChunkName: 'gradingmaster.index' */ "../views/subject/gradingmaster/Index.vue"
      ),
  },
  {
    meta: {
      title: "Grading Rule",
      requireLogin: true,
    },
    path: "/grading-rule",
    name: "gradingrule.index",
    component: () =>
      import(
        /* webpackChunkName: 'gradingrule.index' */ "../views/subject/gradingrule/Index.vue"
      ),
  },
  {
    meta: {
      title: "Copy Syllabus",
      requireLogin: true,
    },
    path: "/copysyllabus",
    name: "syllabuscopy.index",
    component: () =>
      import(
        /* webpackChunkName: 'syllabuscopy.index' */ "../views/subject/syllabuscopy/Index.vue"
      ),
  },
  {
    meta: {
      title: "Regular Subject",
      requireLogin: true,
    },
    path: "/regular-subject-attendance",
    name: "Regular Subject",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'presencelist.index' */ "../views/presence/presencelist/Index.vue"
      ),
  },
  {
    meta: {
      title: "Daily Attendance",
      requireLogin: true,
    },
    path: "/daily-attendance",
    name: "dailyPresence.index",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'presencelist.index' */ "../views/presence/dailyPresence/Index.vue"
      ),
  },
  {
    meta: {
      title: "Parallel Subject",
      requireLogin: true,
    },
    path: "/parallel-subject",
    name: "Parallel Subject",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'presencestreaming.index' */ "../views/presence/presencestreaming/Index.vue"
      ),
  },
  {
    meta: {
      title: "Report Attendance",
      requireLogin: true,
    },
    path: "/reportattendance",
    name: "reportpresence.index",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'reportpresence.index' */ "../views/presence/reportpresence/Index.vue"
      ),
  },
  {
    meta: {
      title: "Report Attendance Streaming",
      requireLogin: true,
    },
    path: "/reportattendance-streaming",
    name: "reportpresencestreaming.index",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'reportpresencestreaming.index' */ "../views/presence/reportpresencestreaming/Index.vue"
      ),
  },
  {
    meta: {
      title: "Report Attendance Daily",
      requireLogin: true,
    },
    path: "/report-attendance-daily",
    name: "reportpresencedaily.index",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'reportpresencedaily.index' */ "../views/presence/reportpresencedaily/Index.vue"
      ),
  },
  {
    meta: {
      title: "Summary Report",
      requireLogin: false,
    },
    path: "/summary-report",
    name: "summary-report.index",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'studentlatereport.index' */ "../views/presence/studentlatereport/Index.vue"
      ),
  },
  {
    meta: {
      title: "Passing Grade",
      requireLogin: true,
    },
    path: "/scoreminimum",
    name: "scoreminimum.index",
    component: () =>
      import(
        /* webpackChunkName: 'scoreminimum.index' */ "../views/referensi/scoreminimum/Index.vue"
      ),
  },
  {
    meta: {
      title: "Special Assignment",
      requireLogin: true,
    },
    path: "/assignment-special",
    name: "assignment-special.index",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'assignmentspecial.index' */ "../views/assignmentspecial/Index.vue"
      ),
  },
  {
    meta: {
      title: "Regular Subject Attendance",
      requireLogin: true,
    },
    path: "/subject-attendance",
    name: "Regular Subject Attendance",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'regularSubjectAttendance.index' */ "../views/presence/subjectAttendance/Index.vue"
      ),
  },
  {
    meta: {
      title: "Report Attendance Daily Employee",
      requireLogin: true,
    },
    path: "/report-attendance-daily-employee",
    name: "reportpresencedailyemployee.index",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'reportpresencedailyemployee.index' */ "../views/presence/reportpresencedailyemployee/Index.vue"
      ),
  },
  {
    meta: {
      title: "COA",
      requireLogin: true,
    },
    path: "/coa",
    name: "coa.index",
    component: () =>
      import(
        /* webpackChunkName: 'coa.index' */ "../views/masterkeu/coa/Index.vue"
      ),
  },
  {
    meta: {
      title: "Financial Year",
      requireLogin: true,
    },
    path: "/financial-year",
    name: "financialyear.index",
    component: () =>
      import(
        /* webpackChunkName: 'financialyear.index' */ "../views/masterkeu/financialyear/Index.vue"
      ),
  },
  {
    meta: {
      title: "Setting Email",
      requireLogin: true,
    },
    path: "/settingemail",
    name: "settingemail.index",
    component: () =>
      import(
        /* webpackChunkName: 'settingemail.index' */ "../views/masterkeu/settingemail/Index.vue"
      ),
  },
  {
    meta: {
      title: "VA Code",
      requireLogin: true,
    },
    path: "/vacode",
    name: "vacode.index",
    component: () =>
      import(
        /* webpackChunkName: 'vacode.index' */ "../views/masterkeu/vacode/Index.vue"
      ),
  },
  {
    meta: {
      title: "Setting Odoo",
      requireLogin: true,
    },
    path: "/settingodoo",
    name: "settingodoo.index",
    component: () =>
      import(
        /* webpackChunkName: 'settingodoo.index' */ "../views/masterkeu/settingodoo/Index.vue"
      ),
  },
  {
    meta: {
      title: "Email Template",
      requireLogin: true,
    },
    path: "/templateemail",
    name: "templateemail.index",
    component: () =>
      import(
        /* webpackChunkName: 'templateemail.index' */ "../views/masterkeu/templateemail/Index.vue"
      ),
  },
  {
    meta: {
      title: "Income Type",
      requireLogin: true,
    },
    path: "/typesofincome",
    name: "typesofincome.index",
    component: () =>
      import(
        /* webpackChunkName: 'typesofincome.index' */ "../views/masterkeu/typesofincome/Index.vue"
      ),
  },
  {
    meta: {
      title: "VA Student",
      requireLogin: true,
    },
    path: "/vastudent",
    name: "vastudent.index",
    component: () =>
      import(
        /* webpackChunkName: 'vastudent.index' */ "../views/masterkeu/vastudent/Index.vue"
      ),
  },
  {
    meta: {
      title: "Income",
      requireLogin: true,
    },
    path: "/income",
    name: "income.index",
    component: () =>
      import(
        /* webpackChunkName: 'income.index' */ "../views/masterkeu/income/Index.vue"
      ),
  },
  {
    meta: {
      title: "Income Type Bank",
      requireLogin: true,
    },
    path: "/incometypebank",
    name: "incometypebank.index",
    component: () =>
      import(
        /* webpackChunkName: 'incometypebank.index' */ "../views/masterkeu/IncomeTypeBank/Index.vue"
      ),
  },
  {
    meta: {
      title: "Bank",
      requireLogin: true,
    },
    path: "/bank",
    name: "bank.index",
    component: () =>
      import(
        /* webpackChunkName: 'bank.index' */ "../views/masterkeu/Bank/Index.vue"
      ),
  },
  {
    meta: {
      title: "General",
      requireLogin: true,
    },
    path: "/general",
    name: "general.index",
    component: () =>
      import(
        /* webpackChunkName: 'general.index' */ "../views/masterkeu/general/Index.vue"
      ),
  },
  {
    meta: {
      title: "Generate Penalty",
      requireLogin: true,
    },
    path: "/generatepenalty",
    name: "generatepenalty.index",
    component: () =>
      import(
        /* webpackChunkName: 'generatepenalty.index' */ "../views/masterkeu/generatepenalty/Index.vue"
      ),
  },
  {
    meta: {
      title: "Upload Income",
      requireLogin: true,
    },
    path: "/uploadincome",
    name: "uploadincome.index",
    component: () =>
      import(
        /* webpackChunkName: 'uploadincome.index' */ "../views/masterkeu/uploadincome/Index.vue"
      ),
  },
  {
    meta: {
      title: "General Journal",
      requireLogin: true,
    },
    path: "/journal",
    name: "journal.index",
    component: () =>
      import(
        /* webpackChunkName: 'journal.index' */ "../views/masterkeu/journal/Index.vue"
      ),
  },
  {
    meta: {
      title: "Reversing Date",
      requireLogin: true,
    },
    path: "/reversingdate",
    name: "reversingdate.index",
    component: () =>
      import(
        /* webpackChunkName: 'reversingdate.index' */ "../views/masterkeu/reversingdate/Index.vue"
      ),
  },
  {
    meta: {
      title: "Generate VA Invoice",
      requireLogin: true,
    },
    path: "/generateva",
    name: "generateva.index",
    component: () =>
      import(
        /* webpackChunkName: 'generateva.index' */ "../views/masterkeu/generateva/Index.vue"
      ),
  },
  {
    meta: {
      title: "Import VA",
      requireLogin: true,
    },
    path: "/uploadva",
    name: "uploadva.index",
    component: () =>
      import(
        /* webpackChunkName: 'uploadva.index' */ "../views/masterkeu/uploadva/Index.vue"
      ),
  },
  {
    meta: {
      title: "AR Outstanding",
      requireLogin: true,
    },
    path: "/aroutstanding",
    name: "aroutstanding.index",
    component: () =>
      import(
        /* webpackChunkName: 'aroutstanding.index' */ "../views/masterkeu/aroutstanding/Index.vue"
      ),
  },
  {
    meta: {
      title: "AR Outstanding",
      requireLogin: true,
    },
    path: "/ardashboard-new",
    name: "ardashboardNew.index",
    component: () =>
      import(
        /* webpackChunkName: 'ardashboard.index' */ "../views/masterkeu/ardashboardNew/Index.vue"
      ),
  },
  {
    meta: {
      title: "Payment",
      requireLogin: true,
    },
    path: "/paymentdashboard",
    name: "paymentdashboard.index",
    component: () =>
      import(
        /* webpackChunkName: 'paymentdashboard.index' */ "../views/masterkeu/paymentdashboard/Index.vue"
      ),
  },
  {
    meta: {
      title: "AR Aging",
      requireLogin: true,
    },
    path: "/araging",
    name: "araging.index",
    component: () =>
      import(
        /* webpackChunkName: 'araging.index' */ "../views/masterkeu/araging/Index.vue"
      ),
  },
  {
    meta: {
      title: "Invoice Transaction",
      requireLogin: true,
    },
    path: "/invoicetransaction",
    name: "invoicetransaction.index",
    component: () =>
      import(
        /* webpackChunkName: 'invoicetransaction.index' */ "../views/masterkeu/invoicetransaction/Index.vue"
      ),
  },
  {
    meta: {
      title: "Invoice Transaction",
      requireLogin: true,
    },
    path: "/invoicetransaction-parent",
    name: "invoicetransaction-parent.index",
    component: () =>
      import(
        /* webpackChunkName: 'invoicetransactionparent.index' */ "../views/masterkeu/invoicetransactionparent/Index.vue"
      ),
  },
  {
    meta: {
      title: "Payment Transaction",
      requireLogin: true,
    },
    path: "/paymenttransaction",
    name: "paymenttransaction.index",
    component: () =>
      import(
        /* webpackChunkName: 'paymenttransaction.index' */ "../views/masterkeu/paymenttransaction/Index.vue"
      ),
  },
  {
    meta: {
      title: "Upload Payment Report",
      requireLogin: true,
    },
    path: "/paymentreportimport",
    name: "paymentreportimport.index",
    component: () =>
      import(
        /* webpackChunkName: 'paymentreportimport.index' */ "../views/masterkeu/paymentreportimport/Index.vue"
      ),
  },
  {
    meta: {
      title: "Report Candidate Payment",
      requireLogin: true,
    },
    path: "/reportcandidatepayment",
    name: "reportcandidatepayment.index",
    component: () =>
      import(
        /* webpackChunkName: 'reportcandidatepayment.index' */ "../views/masterkeu/reportcandidatepayment/Index.vue"
      ),
  },
  {
    meta: {
      title: "Report Credit Status",
      requireLogin: true,
    },
    path: "/reportcreditstatus",
    name: "reportcreditstatus.index",
    component: () =>
      import(
        /* webpackChunkName: 'reportcreditstatus.index' */ "../views/masterkeu/reportcreditstatus/Index.vue"
      ),
  },
  {
    meta: {
      title: "Pyment Transaction",
      requireLogin: true,
    },
    path: "/paymenttransaction-parent",
    name: "paymenttransaction-parent.index",
    component: () =>
      import(
        /* webpackChunkName: 'paymenttransactionparent.index' */ "../views/masterkeu/paymenttransactionparent/Index.vue"
      ),
  },
  {
    meta: {
      title: "Permissions",
      requireLogin: true,
    },
    path: "/permissions-parent",
    name: "permission-parent.index",
    component: () =>
      import(
        /* webpackChunkName: 'permissionparent.index' */ "../views/permissionparent/Index.vue"
      ),
  },
  {
    meta: {
      title: "Attendance List",
      requireLogin: true,
    },
    path: "/attendance-list-parent",
    name: "presencelist-parent.index",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'presencelistparent.index' */ "../views/presence/presencelistparent/Index.vue"
      ),
  },
  {
    meta: {
      title: "Attendance Streaming",
      requireLogin: true,
    },
    path: "/attendance-streaming-parent",
    name: "presencestreaming-parent.index",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'presencestreamingparent.index' */ "../views/presence/presencestreamingparent/Index.vue"
      ),
  },
  {
    meta: {
      title: "Report Attendance Daily",
      requireLogin: true,
    },
    path: "/report-attendance-daily-parent",
    name: "reportpresencedaily-parent.index",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'reportpresencedailyparent.index' */ "../views/presence/reportpresencedailyparent/Index.vue"
      ),
  },
  {
    meta: {
      title: "Send Email",
      requireLogin: true,
    },
    path: "/sendemail",
    name: "sendemail.index",
    component: () =>
      import(
        /* webpackChunkName: 'sendemail.index' */ "../views/masterkeu/sendemail/Index.vue"
      ),
  },
  {
    meta: {
      title: "Journal Type",
      requireLogin: true,
    },
    path: "/typejournal",
    name: "typejournal.index",
    component: () =>
      import(
        /* webpackChunkName: 'typejournal.index' */ "../views/masterkeu/typejournal/Index.vue"
      ),
  },
  {
    meta: {
      title: "Payment",
      requireLogin: true,
    },
    path: "/payment",
    name: "payment.index",
    component: () =>
      import(
        /* webpackChunkName: 'payment.index' */ "../views/masterkeu/payment/Index.vue"
      ),
  },
  {
    meta: {
      title: "Outbox",
      requireLogin: true,
    },
    path: "/outbox",
    name: "outbox.index",
    component: () =>
      import(
        /* webpackChunkName: 'outbox.index' */ "../views/masterkeu/outbox/Index.vue"
      ),
  },
  {
    meta: {
      title: "Sent",
      requireLogin: true,
    },
    path: "/sent",
    name: "sent.index",
    component: () =>
      import(
        /* webpackChunkName: 'sent.index' */ "../views/masterkeu/sent/Index.vue"
      ),
  },
  {
    meta: {
      title: "Work Unit",
      requireLogin: true,
    },
    path: "/work-unit",
    name: "workunit.index",
    component: () =>
      import(
        /* webpackChunkName: 'workunit.index' */ "../views/employee/workunit/Index.vue"
      ),
  },
  {
    meta: {
      title: "Shift",
      requireLogin: true,
    },
    path: "/shift",
    name: "shift.index",
    component: () =>
      import(
        /* webpackChunkName: 'shift.index' */ "../views/employee/shift/Index.vue"
      ),
  },
  {
    meta: {
      title: "Position",
      requireLogin: true,
    },
    path: "/position",
    name: "position.index",
    component: () =>
      import(
        /* webpackChunkName: 'position.index' */ "../views/employee/position/Index.vue"
      ),
  },
  {
    meta: {
      title: "Leave",
      requireLogin: true,
    },
    path: "/leave",
    name: "leave.index",
    component: () =>
      import(
        /* webpackChunkName: 'leave.index' */ "../views/referensi/leave/Index.vue"
      ),
  },
  // Leave Lama
  // {
  //   meta: {
  //   title: 'Leave Request',
  //   requireLogin: true
  //   },
  //   path: '/reqleave',
  //   name: 'reqleave.index',
  //   component: () => import(/* webpackChunkName: 'reqleave.index' */ '../views/employee/reqleave/Index.vue')
  // },
  {
    meta: {
      title: "Users",
      requireLogin: true,
    },
    path: "/users",
    name: "users.index",
    component: () =>
      import(
        /* webpackChunkName: 'users.index' */ "../views/settings/users/Index.vue"
      ),
  },
  {
    meta: {
      title: "Activate Management",
      requireLogin: true,
    },
    path: "/active-docmag",
    name: "active-docmag.index",
    component: () =>
      import(
        /* webpackChunkName: 'activedocmag.index' */ "../views/settings/activedocmag/Index.vue"
      ),
  },
  {
    meta: {
      title: "General Setting",
      requireLogin: true,
    },
    path: "/general-setting",
    name: "general-setting.index",
    component: () =>
      import(
        /* webpackChunkName: 'general-setting.index' */ "../views/settings/GeneralSetting/Index.vue"
      ),
  },
  {
    meta: {
      title: "Module Setting",
      requireLogin: true,
    },
    path: "/module-setting",
    name: "Module Setting",
    component: () =>
      import(/* webpackChunkName: "ModuleSetting.Index" */ "../views/settings/ModuleSetting/Index.vue"),
  },
  {
    meta: {
      title: "Medical Record",
      requireLogin: true,
    },
    path: "/medical-record",
    name: "Medical Record",
    component: () =>
      import(/* webpackChunkName: "medicalrecord.Index" */ "../views/settings/medicalRecord/Index.vue"),
  },
  {
    meta: {
      title: "Parent User",
      requireLogin: true,
    },
    path: "/parent-user",
    name: "parentuser.index",
    component: () =>
      import(
        /* webpackChunkName: 'students.index' */ "../views/students/students/parantIndex.vue"
      ),
  },
  {
    meta: {
      title: "Setting Attendance",
      requireLogin: true,
    },
    path: "/settingattendance",
    name: "settingpresence.index",
    component: () =>
      import(
        /* webpackChunkName: 'settingpresence.index' */ "../views/settings/settingpresence/Index.vue"
      ),
  },
  {
    meta: {
      title: "Reminder Setting",
      requireLogin: true,
    },
    path: "/reminder-setting",
    name: "Reminder Setting",
    component: () =>
      import(
        /* webpackChunkName: 'ReminderSetting.index' */ "../views/settings/ReminderSetting/Index.vue"
      ),
  },
  {
    meta: {
      title: "Setting Major & Cross Major",
      requireLogin: true,
    },
    path: "/settingtimeout",

    name: "settingtimeout.index",
    component: () =>
      import(
        /* webpackChunkName: 'settingtimeout.index' */ "../views/settings/settingtimeout/Index.vue"
      ),
  },
  {
    meta: {
      title: "Setting Extracuricular",
      requireLogin: true,
    },
    path: "/settingextracuricular",

    name: "settingextracuricular.index",
    component: () =>
      import(
        /* webpackChunkName: 'settingextracuricular.index' */ "../views/settings/settingextracuricular/Index.vue"
      ),
  },
  {
    meta: {
      title: "Unapprove Mechanism",
      requireLogin: true,
    },
    path: "/unapprove-mechanism",

    name: "unapprovemechanism.index",
    component: () =>
      import(
        /* webpackChunkName: 'unapprovemechanism.index' */ "../views/settings/unapprovemechanism/Index.vue"
      ),
  },
  {
    meta: {
      title: "Setting Module",
      requireLogin: true,
    },
    path: "/settingmodule",

    name: "settingmodule.index",
    component: () =>
      import(
        /* webpackChunkName: 'settingmodule.index' */ "../views/settings/settingmodule/Index.vue"
      ),
  },
  {
    meta: {
      title: "Event",
      requireLogin: true,
    },
    path: "/major-date",

    name: "majordate.index",
    component: () =>
      import(
        /* webpackChunkName: 'majordate.index' */ "../views/referensi/majordate/Index.vue"
      ),
  },
  {
    meta: {
      title: "Tag",
      requireLogin: true,
    },
    path: "/master-tag",

    name: "mastertag.index",
    component: () =>
      import(
        /* webpackChunkName: 'mastertag.index' */ "../views/referensi/mastertag/Index.vue"
      ),
  },
  {
    meta: {
      title: "Behavior",
      requireLogin: true,
    },
    path: "/behavior",

    name: "behavior.index",
    component: () =>
      import(
        /* webpackChunkName: 'behavior.index' */ "../views/referensi/behavior/Index.vue"
      ),
  },
  {
    meta: {
      title: "Passing Term",
      requireLogin: true,
    },
    path: "/passing-term",

    name: "passingTerm.index",
    component: () =>
      import(
        /* webpackChunkName: 'passingTerm.index' */ "../views/referensi/passingTerm/Index.vue"
      ),
  },
  {
    meta: {
      title: "Holiday",
      requireLogin: true,
    },
    path: "/holiday",

    name: "holiday.index",
    component: () =>
      import(
        /* webpackChunkName: 'holiday.index' */ "../views/masterroom/holiday/Index.vue"
      ),
  },
  {
    meta: {
      title: "Facility",
      requireLogin: true,
    },
    path: "/facility",

    name: "facility.index",
    component: () =>
      import(
        /* webpackChunkName: 'facility.index' */ "../views/masterroom/facility/Index.vue"
      ),
  },
  {
    meta: {
      title: "Room",
      requireLogin: true,
    },
    path: "/room",

    name: "room.index",
    component: () =>
      import(
        /* webpackChunkName: 'room.index' */ "../views/masterroom/room/Index.vue"
      ),
  },
  {
    meta: {
      title: "Vehicle",
      requireLogin: true,
    },
    path: "/vehicle",

    name: "vehicle.index",
    component: () =>
      import(
        /* webpackChunkName: 'vehicle.index' */ "../views/masterroom/vehicle/Index"
      ),
  },
  {
    meta: {
      title: "Setting Rental",
      requireLogin: true,
    },
    path: "/setting-rental",
    name: "settingrental.index",
    component: () =>
      import(
        /* webpackChunkName: 'settingrental.index' */ "../views/masterroom/settingrental/Index.vue"
      ),
  },
  {
    meta: {
      title: "Setting Speedometer",
      requireLogin: true,
    },
    path: "/settingspeed",
    name: "settingspeed.index",
    component: () =>
      import(
        /* webpackChunkName: 'settingspeed.index' */ "../views/settings/settingspeed/Index.vue"
      ),
  },
  {
    meta: {
      title: "Homeroom Ledger Kokurikuler",
      requireLogin: true,
    },
    path: "/ledger-homeroom-attidude",
    name: "ledgerhomeroomattidude.index",
    component: () =>
      import(
        /* webpackChunkName: 'regularhomeroom.index' */ "../views/lessonassessment/regularhomeroom/Index.vue"
      ),
  },
  {
    meta: {
      title: "Regular",
      requireLogin: true,
    },
    path: "/lesson-assessment-regular",
    name: "lessonassessmentregular.index",
    component: () =>
      import(
        /* webpackChunkName: 'regular.index' */ "../views/lessonassessment/regular/Index.vue" //RegularView
      ),
  },
  {
    meta: {
      title: "Regular by Sub Topic",
      requireLogin: true,
    },
    path: "/lesson-assessment-regular-subtopic",
    name: "Regular by Sub Topic",
    component: () =>
      import(
        /* webpackChunkName: 'regularSubtopic.index' */ "../views/lessonassessment/regularSubtopic/index.vue"
      ),
  },
  {
    meta: {
      title: "Report",
      requireLogin: true,
    },
    path: "/student-raport",
    name: "raportstudent.index",
    component: () =>
      import(
        /* webpackChunkName: 'regular.index' */ "../views/raportstudent/Index.vue"
      ),
  },
  {
    meta: {
      title: "Report Passing Term",
      requireLogin: true,
    },
    path: "/passing-term-report",
    name: "passingtermreport.index",
    component: () =>
      import(
        /* webpackChunkName: 'passingtermreport.index' */ "../views/reportpassingterm/Index.vue"
      ),
  },
  {
    meta: {
      title: "Parallel",
      requireLogin: true,
    },
    path: "/lesson-assessment-parallel",
    name: "lessonassessmentparallel.index",
    component: () =>
      import(
        /* webpackChunkName: 'parallel.index' */ "../views/lessonassessment/parallel/Index.vue"
      ),
  },
  {
    meta: {
      title: "Homeroom Ledger",
      requireLogin: true,
    },
    path: "/ledger-homeroom-teacher",
    name: "ledgerhomeroomteacher.index",
    component: () =>
      import(
        /* webpackChunkName: 'ledgerhomeroomteacher.index' */ "../views/lessonassessment/ledgerhomeroomteacher/Index.vue"
      ),
  },
  {
    meta: {
      title: "Extracuricular Score",
      requireLogin: true,
    },
    path: "/extracuricular-score",
    name: "extracuricularScore.index",
    component: () =>
      import(
        /* webpackChunkName: 'extracuricularScore.index' */ "../views/lessonassessment/extracuricularScore/Index.vue"
      ),
  },
  {
    meta: {
      title: "Class Average",
      requireLogin: true,
    },
    path: "/class-average",
    name: "Class Average",
    component: () =>
      import(
        /* webpackChunkName: 'ClassAverage.index' */ "../views/lessonassessment/ClassAverage/Index.vue"
      ),
  },
  // {
  //   meta: {
  //     title: "Aspect Assignment Score",
  //     requireLogin: true,
  //   },
  //   path: "/aspect-assignment-score",
  //   name: "AssignmentScore.index",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'AssignmentScore.index' */ "../views/lessonassessment/AssignmentScore/Index.vue"
  //     ),
  // },
  {
    meta: {
      title: "Attendance Streaming",
      requireLogin: true,
    },
    path: "/attendance-streaming",
    name: "presencestreaming.index",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'presencestreaming.index' */ "../views/presence/presencestreaming/Index.vue"
      ),
  },
  {
    meta: {
      title: "Report Attendance",
      requireLogin: true,
    },
    path: "/reportattendance",
    name: "reportpresence.index",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'reportpresence.index' */ "../views/presence/reportpresence/Index.vue"
      ),
  },
  {
    meta: {
      title: "COA",
      requireLogin: true,
    },
    path: "/coa",
    name: "coa.index",
    component: () =>
      import(
        /* webpackChunkName: 'coa.index' */ "../views/masterkeu/coa/Index.vue"
      ),
  },
  {
    meta: {
      title: "Setting Email",
      requireLogin: true,
    },
    path: "/settingemail",
    name: "settingemail.index",
    component: () =>
      import(
        /* webpackChunkName: 'settingemail.index' */ "../views/masterkeu/settingemail/Index.vue"
      ),
  },
  {
    meta: {
      title: "Inovice Setting",
      requireLogin: true,
    },
    path: "/settingschool",
    name: "settingschool.index",
    component: () =>
      import(
        /* webpackChunkName: 'settingschool.index' */ "../views/masterkeu/settingschool/Index.vue"
      ),
  },
  {
    meta: {
      title: "Publish Setting",
      requireLogin: true,
    },
    path: "/setting-publish",
    name: "settingpublish.index",
    component: () =>
      import(
        /* webpackChunkName: 'settingpublish.index' */ "../views/masterkeu/settingPublish/Index.vue"
      ),
  },
  {
    meta: {
      title: "VA Code",
      requireLogin: true,
    },
    path: "/vacode",
    name: "vacode.index",
    component: () =>
      import(
        /* webpackChunkName: 'vacode.index' */ "../views/masterkeu/vacode/Index.vue"
      ),
  },
  {
    meta: {
      title: "Setting Odoo",
      requireLogin: true,
    },
    path: "/settingodoo",
    name: "settingodoo.index",
    component: () =>
      import(
        /* webpackChunkName: 'settingodoo.index' */ "../views/masterkeu/settingodoo/Index.vue"
      ),
  },
  {
    meta: {
      title: "Email Template",
      requireLogin: true,
    },
    path: "/templateemail",
    name: "templateemail.index",
    component: () =>
      import(
        /* webpackChunkName: 'templateemail.index' */ "../views/masterkeu/templateemail/Index.vue"
      ),
  },
  {
    meta: {
      title: "Types Of Income",
      requireLogin: true,
    },
    path: "/typesofincome",
    name: "typesofincome.index",
    component: () =>
      import(
        /* webpackChunkName: 'typesofincome.index' */ "../views/masterkeu/typesofincome/Index.vue"
      ),
  },
  {
    meta: {
      title: "Income Group",
      requireLogin: true,
    },
    path: "/incomegroup",
    name: "incomegroup.index",
    component: () =>
      import(
        /* webpackChunkName: 'incomegroup.index' */ "../views/masterkeu/incomegroup/Index.vue"
      ),
  },
  {
    meta: {
      title: "Income",
      requireLogin: true,
    },
    path: "/income",
    name: "income.index",
    component: () =>
      import(
        /* webpackChunkName: 'income.index' */ "../views/masterkeu/income/Index.vue"
      ),
  },
  {
    meta: {
      title: "General",
      requireLogin: true,
    },
    path: "/general",
    name: "general.index",
    component: () =>
      import(
        /* webpackChunkName: 'general.index' */ "../views/masterkeu/general/Index.vue"
      ),
  },
  {
    meta: {
      title: "Generate Penalty",
      requireLogin: true,
    },
    path: "/generatepenalty",
    name: "generatepenalty.index",
    component: () =>
      import(
        /* webpackChunkName: 'generatepenalty.index' */ "../views/masterkeu/generatepenalty/Index.vue"
      ),
  },
  {
    meta: {
      title: "General Journal",
      requireLogin: true,
    },
    path: "/journal",
    name: "journal.index",
    component: () =>
      import(
        /* webpackChunkName: 'journal.index' */ "../views/masterkeu/journal/Index.vue"
      ),
  },
  {
    meta: {
      title: "AR Summary",
      requireLogin: true,
    },
    path: "/arsummary",
    name: "arsummary.index",
    component: () =>
      import(
        /* webpackChunkName: 'arsummary.index' */ "../views/masterkeu/arsummary/Index.vue"
      ),
  },
  {
    meta: {
      title: "Financial Report",
      requireLogin: true,
    },
    path: "/financial-report",
    name: "financialReport.index",
    component: () =>
      import(
        /* webpackChunkName: 'financialReport.index' */ "../views/masterkeu/financialReport/Index.vue"
      ),
  },
  {
    meta: {
      title: "Payment Summary By Dept & Class",
      requireLogin: true,
    },
    path: "/paymentsummaryclass",
    name: "paymentsummaryclass.index",
    component: () =>
      import(
        /* webpackChunkName: 'paymentsummaryclass.index' */ "../views/masterkeu/paymentsummaryclass/Index.vue"
      ),
  },
  {
    meta: {
      title: "Payment Summary By Journal Type",
      requireLogin: true,
    },
    path: "/paymentsummarytype",
    name: "paymentsummarytype.index",
    component: () =>
      import(
        /* webpackChunkName: 'paymentsummarytype.index' */ "../views/masterkeu/paymentsummarytype/Index.vue"
      ),
  },
  {
    meta: {
      title: "Generate VA Invoice",
      requireLogin: true,
    },
    path: "/generateva",
    name: "generateva.index",
    component: () =>
      import(
        /* webpackChunkName: 'generateva.index' */ "../views/masterkeu/generateva/Index.vue"
      ),
  },
   {
    meta: {
      title: "Generate VA Invoice",
      requireLogin: true,
    },
    path: "/generateva-new",
    name: "generatevanew.index",
    component: () =>
      import(
        /* webpackChunkName: 'generatevaNew.index' */ "../views/masterkeu/generateva-new/Index.vue"
      ),
  },
  {
    meta: {
      title: "Import VA",
      requireLogin: true,
    },
    path: "/uploadva",
    name: "uploadva.index",
    component: () =>
      import(
        /* webpackChunkName: 'uploadva.index' */ "../views/masterkeu/uploadva/Index.vue"
      ),
  },
  {
    meta: {
      title: "AR Outstanding",
      requireLogin: true,
    },
    path: "/aroutstanding",
    name: "aroutstanding.index",
    component: () =>
      import(
        /* webpackChunkName: 'aroutstanding.index' */ "../views/masterkeu/aroutstanding/Index.vue"
      ),
  },
  {
    meta: {
      title: "Shift",
      requireLogin: true,
    },
    path: "/shift",
    name: "shift.index",
    component: () =>
      import(
        /* webpackChunkName: 'shift.index' */ "../views/employee/shift/Index.vue"
      ),
  },
  {
    meta: {
      title: "Position",
      requireLogin: true,
    },
    path: "/position",
    name: "position.index",
    component: () =>
      import(
        /* webpackChunkName: 'position.index' */ "../views/employee/position/Index.vue"
      ),
  },
  {
    meta: {
      title: "Leave",
      requireLogin: true,
    },
    path: "/leave",
    name: "leave.index",
    component: () =>
      import(
        /* webpackChunkName: 'leave.index' */ "../views/referensi/leave/Index.vue"
      ),
  },
  {
    meta: {
      title: "Leave Request",
      requireLogin: true,
    },
    path: "/reqleave",
    name: "reqleave.index",
    component: () =>
      import(
        /* webpackChunkName: 'reqleave.index' */ "../views/employee/reqleave/Index.vue"
      ),
  },
  {
    meta: {
      title: "Users",
      requireLogin: true,
    },
    path: "/users",
    name: "users.index",
    component: () =>
      import(
        /* webpackChunkName: 'users.index' */ "../views/settings/users/Index.vue"
      ),
  },
  {
    meta: {
      title: "Setting Attendance",
      requireLogin: true,
    },
    path: "/settingattendance",
    name: "settingpresence.index",
    component: () =>
      import(
        /* webpackChunkName: 'settingpresence.index' */ "../views/settings/settingpresence/Index.vue"
      ),
  },
  {
    meta: {
      title: "Forms",
    },
    path: "/forms",
    name: "forms",
    component: () => import(/* webpackChunkName: 'forms' */ "../views/Forms"),
  },
  {
    meta: {
      title: "Profile",
    },
    path: "/profile",
    name: "profile",
    component: () =>
      import(/* webpackChunkName: 'profile' */ "../views/Profile"),
  },
  {
    meta: {
      title: "Employee Profile",
      requireLogin: true,
    },
    path: "/employee-profile",
    name: "Employee Profile",
    component: () =>
      import(/* webpackChunkName: 'profile' */ "../views/profile/Index.vue"),
  },
  {
    meta: {
      title: "Ui",
    },
    path: "/ui",
    name: "ui",
    component: () => import(/* webpackChunkName: 'ui' */ "../views/Ui"),
  },
  {
    meta: {
      title: "Responsive layout",
    },
    path: "/responsive",
    name: "responsive",
    component: () =>
      import(/* webpackChunkName: 'responsive' */ "../views/Responsive"),
  },
  {
    meta: {
      title: "Error",
      fullScreen: true,
    },
    path: "/error",
    name: "error",
    component: () => import(/* webpackChunkName: 'error' */ "../views/Error"),
  },
  {
    meta: {
      title: "Class Transfer",
      requireLogin: true,
    },
    path: "/class-transfer",
    name: "classtransfer.index",
    component: () =>
      import(
        /* webpackChunkName: 'classtransfer.index' */ "../views/students/classtransfer/Index.vue"
      ),
  },
  {
    meta: {
      title: "Violation",
      requireLogin: true,
    },
    path: "/violation",
    name: "violation.index",
    component: () =>
      import(
        /* webpackChunkName: 'violation.index' */ "../views/humanresource/violation/Index.vue"
      ),
  },
  // {
  //   meta: {
  //     title: "Punishment",
  //     requireLogin: true,
  //   },
  //   path: "/punishment",
  //   name: "punishment.index",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'punishment.index' */ "../views/referensi/punishment/Index.vue"
  //     ),
  // },
  {
    meta: {
      title: "Module",
      requireLogin: true,
    },
    path: "/module",
    name: "module.index",
    component: () =>
      import(
        /* webpackChunkName: 'module.index' */ "../views/referensi/module/Index.vue"
      ),
  },

  // -------------- TRANSACTION ROOM BOOKING -------------
  {
    meta: {
      title: "Login Booking",
      fullScreen: true,
    },
    path: "/login-booking",
    name: "Login Booking",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/LoginRoomBooking"),
  },
  {
    meta: {
      title: "Booking",
      fullScreen: true,
    },
    path: "/bookingroom",
    name: "Booking",
    component: () =>
      import(
        /* webpackChunkName: 'roombooking.index' */ "../views/roombooking/IndexBooking.vue"
      ),
    children: [
      {
        meta: {
          title: "Booking - Home",
          requireLogin: true,
        },
        path: "/booking/home",
        name: "booking.home",
        component: () =>
          import(
            /* webpackChunkName: "register" */ "../views/roombooking/HomeSection.vue"
          ),
      },
      {
        meta: {
          title: "Access Grant",
          requireLogin: true,
        },
        path: "/booking/accessgrant",
        name: "accessgrant.index",
        component: () =>
          import(
            /* webpackChunkName: 'register' */ "../views/roombooking/AccessgrantSection.vue"
          ),
      },
      {
        meta: {
          title: "Tenant",
          requireLogin: true,
        },
        path: "/rental/tenant",
        name: "rentaltenant.index",
        component: () =>
          import(
            /* webpackChunkName: 'register' */ "../views/roombooking/TenantSection.vue"
          ),
      },
      {
        meta: {
          title: "Room",
          requireLogin: true,
        },
        path: "/booking/room",
        name: "bookingroom.index",
        component: () =>
          import(
            /* webpackChunkName: 'register' */ "../views/roombooking/RoomSection.vue"
          ),
      },
      {
        meta: {
          title: "Booking",
          requireLogin: true,
        },
        path: "/booking/booking",
        name: "booking.index",
        component: () =>
          import(
            /* webpackChunkName: 'register' */ "../views/roombooking/BookingSection.vue"
          ),
      },
      {
        meta: {
          title: "Select Booking",
          requireLogin: true,
        },
        path: "/booking/select-booking",
        name: "select.index",
        component: () =>
          import(
            /* webpackChunkName: 'register' */ "../views/roombooking/SelectPage.vue"
          ),
      },
      {
        meta: {
          title: "Select Rental",
          requireLogin: true,
        },
        path: "/rental/select-rental",
        name: "selectrental.index",
        component: () =>
          import(
            /* webpackChunkName: 'register' */ "../views/roombooking/SelectPageRental.vue"
          ),
      },
      {
        meta: {
          title: "Vehicle Booking",
          requireLogin: true,
        },
        path: "/booking/vehicle",
        name: "vehiclebooking.index",
        component: () =>
          import(
            /* webpackChunkName: 'register' */ "../views/roombooking/VehicleSection.vue"
          ),
      },
      {
        meta: {
          title: "Google Calendar",
          requireLogin: true,
        },
        path: "/google-calendar",
        name: "googlecalendar.index",
        component: () =>
          import(
            /* webpackChunkName: 'register' */ "../views/roombooking/calendar/CalendarSection.vue"
          ),
      },
      {
        meta: {
          title: "Rental",
          requireLogin: true,
        },
        path: "/rental/rental",
        name: "rental.index",
        component: () =>
          import(
            /* webpackChunkName: 'register' */ "../views/roombooking/RentalSection.vue"
          ),
      },
      {
        meta: {
          title: "Report",
          requireLogin: true,
        },
        path: "/booking/report",
        name: "bookingreport.index",
        component: () =>
          import(
            /* webpackChunkName: 'register' */ "../views/roombooking/ReportSection.vue"
          ),
      },
    ],
  },

  // ------------------- Parent Route -------------------
  {
    meta: {
      title: "Login Parent",
      fullScreen: true,
    },
    path: "/login-parent",
    name: "Login Parent",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/LoginParent"),
  },
  {
    meta: {
      title: "Parent Page",
      requireLogin: true,
    },
    path: "/parent",
    name: "parent.index",
    component: () =>
      import(
        /* webpackChunkName: 'parentPage.index' */ "../views/ParentPage/IndexParent.vue"
      ),
    children: [
      {
        meta: {
          title: "Parent - Home",
          requireLogin: true,
        },
        path: "/parent/home",
        name: "parent.home",
        component: HomeSection,
      },
      {
        meta: {
          title: "Parent - Attendance",
          requireLogin: true,
        },
        path: "/parent/attendance",
        name: "parent.presence",
        component: () =>
          import(
            /* webpackChunkName: 'parentPage.index' */ "../views/ParentPage/PresenceSection.vue"
          ),
      },
      {
        meta: {
          title: "Parent - Subject Attendance",
          requireLogin: true,
        },
        path: "/parent/attendance/subject-attendance",
        name: "subject-presence.index",
        component: () =>
          import(
            /* webpackChunkName: 'presence.index' */ "../views/ParentPage/Presence/RegularSubject.vue"
          ),
      },
      {
        meta: {
          title: "Parent - Daily Attendance",
          requireLogin: true,
        },
        path: "/parent/attendance/daily-attendance",
        name: "daily-presence.index",
        component: () =>
          import(
            /* webpackChunkName: 'presence.index' */ "../views/ParentPage/Presence/DailyPresence.vue"
          ),
      },
      {
        meta: {
          title: "Parent - Extracuricular Attendance",
          requireLogin: true,
        },
        path: "/parent/attendance/extracuricular-attendance",
        name: "Parent - Extracuricular Attendance",
        component: () =>
          import(
            /* webpackChunkName: 'presence.index' */ "../views/ParentPage/Presence/ExculPresence.vue"
          ),
      },
      {
        meta: {
          title: "Parent - Invoice Transaction",
          requireLogin: true,
        },
        path: "/parent/finance/invoice",
        name: "invoice.index",
        component: () =>
          import(
            /* webpackChunkName: 'Payment.Invoice' */ "../views/ParentPage/Payment/Invoice.vue"
          ),
      },
      {
        meta: {
          title: "Parent - Payment Transaction",
          requireLogin: true,
        },
        path: "/parent/finance/payment",
        name: "parent.payment",
        component: () =>
          import(
            /* webpackChunkName: 'Payment.Payment' */ "../views/ParentPage/Payment/Payment.vue"
          ),
      },
      {
        meta: {
          title: "Parent - Waiver Transaction",
          requireLogin: true,
        },
        path: "/parent/finance/waiver",
        name: "parent.waiver",
        component: () =>
          import(
            /* webpackChunkName: 'Payment.Payment' */ "../views/ParentPage/Payment/Waiver.vue"
          ),
      },
      {
        meta: {
          title: "Parent - Finance",
          requireLogin: true,
        },
        path: "/parent/finance",
        name: "finance.index",
        component: () =>
          import(
            /* webpackChunkName: 'parentPage.index' */ "../views/ParentPage/TransactionSection.vue"
          ),
      },
      {
        meta: {
          title: "Parent - Coursework",
          requireLogin: true,
        },
        path: "/parent/coursework",
        name: "parentcoursework.index",
        component: () =>
          import(
            /* webpackChunkName: 'parentcoursework.index' */ "../views/ParentPage/Coursework/CourseworkSection.vue"
          ),
      },
      {
        meta: {
          title: "Parent - Permission",
          requireLogin: true,
        },
        path: "/parent/permission",
        name: "parent.permission",
        component: () =>
          import(
            /* webpackChunkName: 'parentPage.index' */ "../views/ParentPage/PermissionSection.vue"
          ),
      },
      {
        meta: {
          title: "Parent - Academic",
          requireLogin: true,
        },
        path: "/parent/academic",
        name: "parent.academic",
        component: () =>
          import(
            /* webpackChunkName: 'parentPage.index' */ "../views/ParentPage/RemedialSection.vue"
          ),
      },
      {
        meta: {
          title: "Parent - Calendar",
          requireLogin: true,
        },
        path: "/parent/calendar",
        name: "parent.calendar",
        component: () =>
          import(
            /* webpackChunkName: 'parentPage.index' */ "../views/ParentPage/CalendarSection.vue"
          ),
      },
      {
        meta: {
          title: "Parent - Schedule",
          requireLogin: true,
        },
        path: "/parent/schedule",
        name: "parent.schedule",
        component: () =>
          import(
            /* webpackChunkName: 'parentPage.index' */ "../views/ParentPage/ScheduleSection.vue"
          ),
      },
      {
        meta: {
          title: "Parent - Notification",
          requireLogin: true,
        },
        path: "/parent/notification",
        name: "parent.notification",
        component: () =>
          import(
            /* webpackChunkName: 'parentPage.index' */ "../views/ParentPage/NotifSeen.vue"
          ),
      },
    ],
  },

  // ------------------- Student Route -------------------
  {
    meta: {
      title: "Login Student",
      fullScreen: true,
    },
    path: "/login-student",
    name: "Login Student",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/LoginStudent"),
  },
  {
    meta: {
      title: "Student Page",
      requireLogin: true,
    },
    path: "/student",
    name: "student.index",
    component: () =>
      import(
        /* webpackChunkName: 'StudentPage.index' */ "../views/StudentPage/IndexStudent.vue"
      ),
    children: [
      {
        meta: {
          title: "Student - Home",
          requireLogin: true,
        },
        path: "/student/home",
        name: "student.home",
        component: () =>
          import(
            /* webpackChunkName: 'StudentPage.index' */ "../views/StudentPage/HomeSection.vue"
          ),
      },
      {
        meta: {
          title: "Student - Attendance",
          requireLogin: true,
        },
        path: "/student/attendance",
        name: "presence.index",
        component: () =>
          import(
            /* webpackChunkName: 'StudentPage.index' */ "../views/StudentPage/PresenceSection.vue"
          ),
      },
      {
        meta: {
          title: "Student - Subject Attendance",
          requireLogin: true,
        },
        path: "/student/attendance/subject-attendance",
        name: "subject-presence-student.index",
        component: () =>
          import(
            /* webpackChunkName: 'presence.index' */ "../views/StudentPage/Presence/RegularSubject.vue"
          ),
      },
      {
        meta: {
          title: "Student - Daily Attendance",
          requireLogin: true,
        },
        path: "/student/attendance/daily-attendance",
        name: "daily-presence-student.index",
        component: () =>
          import(
            /* webpackChunkName: 'presence.index' */ "../views/StudentPage/Presence/DailyPresence.vue"
          ),
      },
      {
        meta: {
          title: "Permission",
          requireLogin: true,
        },
        path: "/student/permission",
        name: "student.permission",
        component: () =>
          import(
            /* webpackChunkName: 'StudentPage.index' */ "../views/StudentPage/PermissionSection.vue"
          ),
      },
      {
        meta: {
          title: "Coursework",
          requireLogin: true,
        },
        path: "/student/coursework",
        name: "student.coursework",
        component: () =>
          import(
            /* webpackChunkName: 'StudentPage.index' */ "../views/StudentPage/CourseworkSection.vue"
          ),
      },
      {
        meta: {
          title: "Portofolio",
          requireLogin: true,
        },
        path: "/student/portofolio",
        name: "student.portofolio",
        component: () =>
          import(
            /* webpackChunkName: 'StudentPage.index' */ "../views/StudentPage/PortofolioSection.vue"
          ),
      },
      {
        meta: {
          title: "Academic",
          requireLogin: true,
        },
        path: "/student/academic",
        name: "student.academic",
        component: () =>
          import(
            /* webpackChunkName: 'StudentPageacademic.index' */ "../views/StudentPage/RemedialSection.vue"
          ),
      },
      {
        meta: {
          title: "Calendar",
          requireLogin: true,
        },
        path: "/student/calendar",
        name: "student.calendar",
        component: () =>
          import(
            /* webpackChunkName: 'StudentPage.index' */ "../views/StudentPage/CalendarSection.vue"
          ),
      },
      {
        meta: {
          title: "Schedule",
          requireLogin: true,
        },
        path: "/student/schedule",
        name: "student.schedule",
        component: () =>
          import(
            /* webpackChunkName: 'StudentPageschedule.index' */ "../views/StudentPage/ScheduleSection.vue"
          ),
      },
      {
        meta: {
          title: "Student - Notification",
          requireLogin: true,
        },
        path: "/student/notification",
        name: "student.notification",
        component: () =>
          import(
            /* webpackChunkName: 'StudentPage.index' */ "../views/StudentPage/NotifSeen.vue"
          ),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 };
  },
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requireLogin)) {
    // cek route required
    const roles = localStorage.getItem("roles");
    if (store.state.auth.isAuthenticated && localStorage.getItem("roles")) {
      const myArray = ["ROLE_FINANCE"];
      const roleExists = roles
        .split(",")
        .some((value) => myArray.includes(value));
      if (!roleExists) {
        if (to.path === "/") {
          next({ path: "/academic-dashboard" });
          return;
        }
      }
      next();
      return;
    }
    if (localStorage.getItem("user_id") !== null) {
      const myArray = ["ROLE_FINANCE"];
      const roleExists = roles
        .split(",")
        .some((value) => myArray.includes(value));
      if (!roleExists) {
        if (to.path === "/") {
          next({ path: "/academic-dashboard" });
          return;
        }
      }
      next();
      return;
    }

    if (localStorage.getItem("loginAs") === "parent") {
      next({ path: "/login-parent", query: { to: to.path } });
      return;
    } else if (localStorage.getItem("loginAs") === "student") {
      next({ path: "/login-student", query: { to: to.path } });
      return;
    } else if (localStorage.getItem("loginAs") === "booking") {
      next({ path: "/login-booking", query: { to: to.path } });
      return;
    } else {
      next({ path: "/login", query: { to: to.path } });
      return;
    }
  }
  next();
});
export default router;
